// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"

// Scroll to top only when navigating via footer links
let _footerNav = false
document.addEventListener("turbo:click", (e) => {
  _footerNav = !!e.target.closest("footer")
})
document.addEventListener("turbo:load", () => {
  if (!_footerNav) return
  _footerNav = false
  // scroll-smooth on <html> causes smooth animation that Turbo interrupts mid-render
  // override inline to force instant scroll, then restore
  const html = document.documentElement
  html.style.scrollBehavior = "auto"
  window.scrollTo(0, 0)
  html.style.scrollBehavior = ""
})
